app.provider('countryConfig', function () {
    var a_config = {};

    // Detect domain name to switch config.
    var origin = window.location.origin;
    if (origin.indexOf("au.cattrax.co.nz") !== -1
        //|| origin.indexOf("localhost") !== -1
        ) {
        // --- AUSTRALIA CONFIG ---
        a_config = {
            countryCode: 'AU',
            nhiFeatureEnabled: false,
            // No SMS gateway here, so a mobile number can never be verified - the server issues
            // email-only tokens. Showing a mobile verification state would be showing one that can
            // only ever say "unverified", which reads as a fault rather than as a fact of the market.
            mobileVerificationEnabled: false,
            medicareFeatureEnabled: true,
            clinicalLettersFeatureEnabled: false,
            referralFeatureEnabled: false,
            sendProgressNoteToGpFeatureEnabled: false,
            nzfMedicationsFeatureEnabled: false,
            ePrescriptionsFeatureEnabled: false,
            transcriptionFeatureEnabled: false,
            // Printed prescriptions go onto pre-printed Services Australia PBS/RPBS stationery, so the
            // medication form asks for the PBS fields (quantity, repeats, brand substitution, authority)
            // and the prescriber's PBS prescriber number is captured in their profile.
            pbsPrescriptionFeatureEnabled: true,
            advancedSearchLabel: "Last name, Medicare number, DVA number, IHI, phone or email",
            // The law the patient-facing consents are given under, named on the consent steps of the
            // verification page. Per country because the page is served to patients in both, and NZ
            // legislation means nothing to an Australian patient being asked to consent.
            //
            // Order is the reading order; the page joins them with commas and a final "and". An empty
            // array hides the block entirely, which is the escape hatch for a country whose wording
            // has not been settled yet.
            consentLegislation: [
                {
                    label: "Australian Privacy Principles",
                    url: "https://www.oaic.gov.au/privacy/australian-privacy-principles", 
                },
                {
                    label: "Privacy Act 1988",
                    url: "https://www.legislation.gov.au/C2004A03712/latest/text",
                },
            ],
        };
    } else {
        // --- NEW ZEALAND CONFIG ---
        a_config = {
            countryCode: 'NZ',
            nhiFeatureEnabled: true,
            mobileVerificationEnabled: true,
            medicareFeatureEnabled: false,
            clinicalLettersFeatureEnabled: true,
            referralFeatureEnabled: true,
            sendProgressNoteToGpFeatureEnabled: true,
            nzfMedicationsFeatureEnabled: true,
            ePrescriptionsFeatureEnabled: true,
            // On for every NZ practice. This replaced practiceFeatures.elevenLabsTranscriptionFeature,
            // which is deprecated: the server still returns it, but nothing reads it any more.
            transcriptionFeatureEnabled: true,
            pbsPrescriptionFeatureEnabled: false,
            advancedSearchLabel: "Last name, NHI, phone or email",
            // See the note on the Australian block above.
            consentLegislation: [
                {
                    label: "Health Information Privacy Code 2020",
                    url: "https://www.privacy.org.nz/privacy-act-2020/codes-of-practice/hipc2020/",
                },
                {
                    label: "NZ Privacy Act 2020",
                    url: "https://www.legislation.govt.nz/act/public/2020/0031/latest/LMS23223.html",
                },
            ],
        };
    }

    this.$get = function () {
        return a_config;
    };
});